// Central configuration for Fantasy Pals.
// Update these values here instead of hunting through components.

// The Fantasy Pals elimination league (the "primary" league shown at the top).
export const PRIMARY_LEAGUE_ID = 175750856;

// ESPN season to display. NFL seasons are labeled by their starting year, so
// this is set explicitly rather than derived from the current date (which would
// otherwise roll over to the wrong year during Jan–Aug of the following year).
export const CURRENT_SEASON = 2026;

// Seed data only. The live pal list now comes from the Supabase `connections`
// table (see src/connections.js). These three rows were the original hardcoded
// pals; use them once to seed Supabase, then connections are managed in-app.
export const PALS_SEED = [
  { name: 'Josh', id: '1661561268', team: 1 },
  { name: 'Luke', id: '286565', team: 7 },
  { name: 'Boozie', id: '319397', team: 11 },
];

// League documentation now lives in-app on the /docs routes declared in
// App.js, backed by the markdown in public/docs (see src/docs/manifest.js).

// The public Notion page the docs were migrated from. Kept only for the
// "these pages replace…" footnote on the docs index; safe to drop once
// everyone has stopped reaching for the old bookmark.
export const LEGACY_DOCS_URL = 'https://bit.ly/fantasypals';

export const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@FantasyPalsOnline';

export const CONTACT_EMAIL = 'fantasypalsonline@gmail.com';
